import { useCallback } from 'react'
import { useAtomValue, useSetAtom } from 'jotai'
import { DATADOG_ACTIONS } from '@app/app-constants'
import { infoLayerFocusAtom, RiskSideDrawerLayerTabs } from '@app/state/layerAtom'
import type { MapLayer, SimplifiedGeoJSONFeature } from '@app/types/layerTypes'
import { logDataDogAction } from '@app/utils/logger'
import { riskMapInstanceAtom, selectedFeatureAtom, selectedLayerAtom } from '../atoms/riskMap.atoms'

export function useSelectRiskFeature() {
  const setSelectedFeature = useSetAtom(selectedFeatureAtom)
  const setSelectedLayer = useSetAtom(selectedLayerAtom)
  const map = useAtomValue(riskMapInstanceAtom)
  const setSideDrawerInfoLayerFocus = useSetAtom(infoLayerFocusAtom)

  return useCallback(
    (
      feature: mapboxgl.MapboxGeoJSONFeature,
      layer: MapLayer,
      layerCategory: RiskSideDrawerLayerTabs,
    ) => {
      if (!map) return false

      setSideDrawerInfoLayerFocus(layerCategory)

      setSelectedFeature(feature as unknown as SimplifiedGeoJSONFeature)
      setSelectedLayer(layer)

      logDataDogAction(DATADOG_ACTIONS.SELECT_FEATURE, {
        id: layer.type ?? layer.id,
        type: layer.type ? 'asset' : 'information',
      })

      return true
    },
    [map, setSelectedFeature, setSelectedLayer, setSideDrawerInfoLayerFocus],
  )
}
